// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__uUoef","songPlayed":"Sidebar_songPlayed__x0J2c","active":"Sidebar_active__-kWc9","icon":"Sidebar_icon__s+PB3","text":"Sidebar_text__+yte+"};